import { INSTANCE, INSTANCELIST } from './API'

export const getCustomers = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/customers/details',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify(filter),
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const findCustomersByPhone = (phone, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'get',
            url: `/customers/by-phone/${encodeURIComponent(phone)}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => resolve(response?.list || []))
            .catch((err) => {
                if (err?.response?.status === 404) {
                    resolve([])
                    return
                }
                reject(err)
            })
    })

export const getCustomersSelect = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { token, filter = {}, search, includeIds = [] } = queryKey[1]

        const baseFilter = {
            ...filter,
            status: { $ne: 'discontinued' },
        }

        let apiFilter = baseFilter

        if (search) {
            const searchFilter = {
                ...baseFilter,
                name: { $regex: search, $options: 'i' },
            }
            apiFilter = includeIds.length
                ? {
                      $or: [{ id: { $in: includeIds } }, searchFilter],
                  }
                : searchFilter
        } else if (includeIds.length) {
            apiFilter = {
                $or: [{ id: { $in: includeIds } }, baseFilter],
            }
        }

        INSTANCELIST({
            method: 'get',
            url: '/customers/details',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(['name', 'ASC']),
                range: JSON.stringify([0, 19]),
                filter: JSON.stringify(apiFilter),
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getCustomersWithAreas = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/customers/areas',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify({
                    ...filter,
                    status: { $ne: 'discontinued' }
                }),
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getCustomersVoucher = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { filter, sort, token } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/vouchers/details',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                filter: JSON.stringify(filter),
                sort: JSON.stringify(sort),
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const CustomerDetails = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { userId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/customers/${userId}/details`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getCustomerLoyaltyHistory = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { userId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/loyalty-point-histories/customer/${userId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const adjustCustomerLoyaltyPoints = (userId, { amount, comment }, token) =>
    new Promise((resolve, reject) => {
        const body = { amount }
        if (comment?.trim()) {
            body.comment = comment.trim()
        }

        INSTANCE({
            method: 'post',
            url: `loyalty-point-histories/customer/${userId}/adjust`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(body),
        })
            .then(resolve)
            .catch(reject)
    })

export const CreateCustomer = (form, token) =>
    new Promise((resolve, reject) => {
        form.flagged = false

        const cleanGroup = []
        form.wechatGroups.map((commu) =>
            commu.groupNumber ? cleanGroup.push(commu) : null
        )
        form.wechatGroups = cleanGroup

        INSTANCE({
            method: 'post',
            url: '/customers',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const EditCustomer = (form, token, customerId) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/customers/${customerId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })
